import { Decoder, tools, Reader } from "ts-ebml";
import { addFileInfo, blobToArrayBuffer } from "./utils/file-util";

class Converter {
  async convert(data) {
    const decoder = new Decoder();
    const reader = new Reader();
    reader.logging = false;
    reader.drop_default_duration = false;

    // save timestamp
    const timestamp = new Date();
    timestamp.setTime(data.lastModified);

    // load and convert blob
    const buffer = await this.loadBlob(data);

    // decode
    const elms = decoder.decode(buffer);
    elms.forEach(elm => {
      reader.read(elm);
    });
    reader.stop();

    // generate metadata
    let refinedMetadataBuf = tools.makeMetadataSeekable(
      reader.metadatas,
      reader.duration,
      reader.cues
    );
    let body = buffer.slice(reader.metadataSize);

    // create new blob
    let result = new Blob([refinedMetadataBuf, body], { type: data.type });

    // add existing file info
    this.addFileInfo(result, timestamp);

    // store result
    return result;
  }

  loadBlob(data) {
    return blobToArrayBuffer(data);
  }

  addFileInfo(fileObj, now) {
    addFileInfo(fileObj, now);
  }
}

const ConverterInstance = new Converter();

export default ConverterInstance;
